<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <card>
            <div class="row">
              <div class="col-md-4">
                <label for="tecnologia">Tecnologia</label>
                <select v-model="produto.tecnologia" class="form-control">
                  <option
                    v-for="option in tecnologiaOptions"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></option>
                </select>
              </div>
              <div class="col-md-4">
                <label for="tecnologia">Produto</label>
                <select v-model="produto.estrutura" class="form-control">
                  <option
                    v-for="option in estruturaOptions"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></option>
                </select>
              </div>
              <div class="col-md-4">
                <base-input
                  type="text"
                  label="Fornecedor"
                  placeholder="Fornecedor"
                  v-model="produto.fornecedor"
                ></base-input>
              </div>
            </div>
            <div class="float-right">
              <button
                class="btn btn-info btn-fill mr-3"
                @click.prevent
                @click="clearFilters()"
              >
                <i class="fa fa-remove"></i>
                Limpar Filtros
              </button>
              <button
                class="btn btn-success btn-fill"
                @click.prevent
                @click="loadList()"
              >
                <i class="fa fa-search"></i>
                Buscar
              </button>
            </div>
          </card>
          <div class="container-fluid">
            <div class="row">
              <div
                class="col-md-3 col-sm-12 col-12"
                v-for="product in productList"
                v-bind:key="product._id"
              >
                <card class="card-user">
                  <div style="text-align: center">
                    <img
                      class="product-photo"
                      :src="product.imagem"
                      alt="foto do kit"
                    />
                    <h4 class="title">
                      {{ product.nome }} kWp
                      <br />
                      <small>{{ product.fornecedor }}</small>
                    </h4>
                  </div>
                  <hr class="ml-0 mr-0" />
                  <div class="row ml-1">
                    <em>Módulo:</em>
                    <p class="ml-2">
                      {{ product.moduloQuantidade }}x
                      <strong>{{ product.moduloPotencia }}</strong>
                      {{ product.moduloFabricante }}
                    </p>
                  </div>
                  <div class="row ml-1">
                    <em>Inversor:</em>
                    <p class="ml-2">
                      {{ product.inversorQuantidade }}x
                      <strong>{{ product.inversorPotencia }}</strong>
                      {{ product.inversorFabricante }}
                    </p>
                  </div>
                  <div class="row ml-1">
                    <em>Estrutura:</em>
                    <strong class="ml-2">{{
                      getEstrutura(product.tipoEstrutura)
                    }}</strong>
                  </div>
                  <div class="row ml-1 mt-3">
                    <em>Tecnologia:</em>
                    <strong class="ml-2">{{
                      getTecnologia(product.tipoTecnologia)
                    }}</strong>
                  </div>
                  <div class="row ml-1 mt-3">
                    <em>Valor:</em>
                    <strong class="ml-2">{{
                      parseInt(product.valor).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    }}</strong>
                  </div>
                  <div
                    slot="footer"
                    class="text-center d-flex justify-content-center"
                  >
                    <button
                      class="btn btn-success btn-fill"
                      @click.prevent
                      @click="requestProduct(product)"
                    >
                      Solicitar
                    </button>
                  </div>
                </card>
              </div>
            </div>
            <v-pagination
              v-if="productList.length > 0"
              v-model="currentPage"
              :page-count="totalPages"
              :classes="bootstrapPaginationClasses"
              :labels="paginationAnchorTexts"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import _ from 'lodash';
import ProdutosServices from 'src/services/produtos';
import vPagination from 'vue-plain-pagination';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card,
    vPagination
  },
  props: {},
  data() {
    return {
      produto: {
        fornecedor: '',
        tecnologia: '',
        estrutura: ''
      },
      estruturaOptions: [
        { value: 'fibrocimento', label: 'Fibrocimento' },
        { value: 'laje', label: 'Laje' },
        { value: 'canal', label: 'Canal' },
        { value: 'metalico', label: 'Metálico' },
        { value: 'Solo', label: 'Solo' }
      ],
      tecnologiaOptions: [
        { value: 'inversor-string', label: 'Inversor String' },
        { value: 'micro-inversor', label: 'Microinversor' },
        { value: 'solar-edge', label: 'SolarEdge' }
      ],
      productList: [],
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      }
    };
  },
  created() {
    this.loadList();
  },
  computed: {},
  methods: {
    getEstrutura(estrutura) {
      switch (estrutura) {
        case 'fibrocimento':
          return 'Fibrocimento';
        case 'laje':
          return 'Laje';
        case 'canal':
          return 'Canal';
        case 'metalico':
          return 'Metálico';
        case 'Solo':
          return 'Solo';
      }
    },
    getTecnologia(tecnologia) {
      switch (tecnologia) {
        case 'inversor-string':
          return 'Inversor String';
        case 'micro-inversor':
          return 'Microinversor';
        case 'solar-edge':
          return 'SolarEdge';
      }
    },
    clearFilters() {
      this.produto.fornecedor = '';
      this.produto.tecnologia = '';
      this.produto.estrutura = '';
      this.loadList();
    },
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      ProdutosServices.listar({
        page: this.currentPage,
        fornecedor: this.produto.fornecedor,
        tecnologia: this.produto.tecnologia,
        estrutura: this.produto.estrutura
      })
        .then(response => {
          const resultsWithValueAsString = _.get(response, 'data.result').map(
            element => ({
              ...element,
              valor: element.valor.$numberDecimal,
              nome: element.nome.$numberDecimal
            })
          );
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 12);
          loader.hide();
          this.productList = resultsWithValueAsString;
        })
        .catch(err => {
          const message =
            _.get(err, 'response.status') === 400 &&
            _.has(err, 'response.data.message')
              ? _.get(err, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.notifyVue(
            'top',
            'center',
            'danger',
            message,
            'fa fa-exclamation-triangle'
          );
          loader.hide();
        });
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    requestProduct(product) {
      window.open(
        'https://wa.me/5581995212354?text=Ol%C3%A1%2C+me+interessei+no+seguinte+produto%3A%0A' +
          'M%C3%B3dulo%3A+' +
          product.moduloQuantidade +
          'x' +
          '+' +
          product.moduloPotencia +
          '+' +
          product.moduloFabricante +
          '+%0A' +
          'Inversor%3A+' +
          '+' +
          product.inversorQuantidade +
          'x+' +
          product.inversorPotencia +
          '+' +
          product.inversorFabricante +
          '+%0A' +
          'Estrutura%3A+' +
          product.tipoEstrutura +
          '+%0A' +
          'Tecnologia%3A+' +
          product.tipoTecnologia +
          '+%0A' +
          'Valor%3A+' +
          'R$' +
          product.valor.replace('.', ',')
      );
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>

<style>
.product-photo {
  width: 95%;
  min-width: 8em;
  margin: 3%;
  margin-bottom: 0;
  border: outset;
}

.pagination {
  justify-content: center;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
</style>
